
function extractProvinceSelectInput(provinceList) {
	let ret = [];
	if(provinceList){
		if(provinceList.length > 0){
			for (var i = 0; i < provinceList.length; i++){
				if(provinceList[i].name){
					ret.push(provinceList[i].name);
				}
			}
		}
	}
    return ret;
}

// function truckTypeLookupValue(truckTypeList, id) {
// 	let ret = null;
// 	if(truckTypeList){
// 		if(truckTypeList.length > 0){
// 			for (var i = 0; i < truckTypeList.length; i++){
// 				if(truckTypeList[i]._id === id){
// 					ret = truckTypeList[i].typeName;
// 				}
// 			}
// 		}
// 	}
//     return ret;
// }

// function truckTypeLookupKey(truckTypeList, typeName) {
//     let ret = null;
// 	if(truckTypeList){
// 		if(truckTypeList.length > 0){
// 			for (var i = 0; i < truckTypeList.length; i++){
// 				if(truckTypeList[i].typeName === typeName){
// 					ret = truckTypeList[i]._id;
// 				}
// 			}
// 		}
// 	}
//     return ret;
// }


export { 
	extractProvinceSelectInput, 
	// truckTypeLookupValue,
	// truckTypeLookupKey,

};